<template>
    <div class="users-style">

        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance Settings<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance Settings / 
            <template v-if="roster == 1">Shift Management</template>
            <template v-else>Office Time Settings</template>
        </span>
        </h4>

        <div class="row no-margin mt-4">
            <div class="ibox col-md-12 px-4">
                <div class="ibox-title pt-4 dashboard_title company-form-box-title pf-contribution pl-0 pt-0 pb-0 roster-ibox">
                    <h4 class="clearfix mb-0">
                        <span class="float-left">
                            <template v-if="roster == 1">Shift Management</template>
                            <template v-else>Office Time Settings</template>
                            <span class="title-sub-text"></span>
                        </span>
                        <span class="float-right"></span>
                    </h4>
                </div>

                <div class="ibox-content px-0 employee-table-wrapper">
                    <div class="row no-gutters py-2 mb-3 pl-0">
                        <div class="col-sm-6">
                            <div class="custom-search">
                                <b-input-group class="mb-0">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="search"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                        <div class="col-sm-6 pr-0 cursor-pointer text-right company-form-box-title">
                            <b-button id="show-btn" class="" @click="openCreate">
                                <template v-if="roster == 1">+ Create Shift</template>
                                <template v-else>+ Add Office Time</template>                                
                            </b-button>
                        </div>
                    </div>

                    <table class="table dataTable no-sort-icon leave-table">
                        <thead>
                            <tr class="table-head">
                                <td>Name</td>
                                <td>Code</td>
                                <td>Color</td>
                                <td>Start Time</td>
                                <td>End Time</td>
                                <td>Start Window (Minutes)</td>
                                <td>End Window (Minutes)</td>
                                <td>Break Time</td>
                                <td>Working Time</td>
                                <td>Break Included</td>
                                <td>Night Shift</td>
                                <td v-if="grace">Grace Time</td>
                                <th class="text-right">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hover-bg table-row border-bottom mx-2" v-for="(s, index) in paginatedData" :key="s.id">
                                <td>{{ s.name }}</td>
                                <td>{{ s.code }}</td>
                                <td><div :style="{ background: s.color }" class="w-100 rounded py-3"></div></td>
                                <td>{{ moment(s.start_time, 'HH:mm:ss').format('hh:mm A') }}</td>
                                <td>{{ moment(s.end_time, 'HH:mm:ss').format('hh:mm A') }}</td>
                                <td>{{ s.window_start }} minutes</td>
                                <td>{{ s.window_end }} minutes</td>
                                <td>{{ s.break_minutes }} minutes</td>
                                <td>{{ computeWorking(s) }}</td>
                                <td class="text-center">{{ s.break_included ? 'Yes' : 'No' }}</td>
                                <td class="text-center">{{ s.is_night ? 'Yes' : 'No' }}</td>
                                <td v-if="grace" class="text-center">{{ s.grace ? 'Yes' : 'No' }}</td>
                                <td>
                                    <div class="float-right position-relative">
                                        <b-button-toolbar>
                                            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                            <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                <b-button-group class="mr-0">
                                                    <b-button variant="outline-secondary" @click="openEdit(s)">
                                                        <b-icon icon="pencil"></b-icon> Edit
                                                    </b-button>
                                                    <b-button variant="outline-secondary" @click="remove(s.id)">
                                                        <b-icon icon="trash"></b-icon> Delete
                                                    </b-button>
                                                </b-button-group>
                                            </div>
                                        </b-button-toolbar>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                    <div v-else class="px-3">
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{ shifts.length }} records found.</li>
                        </ul>
                        <b-pagination-nav v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number></b-pagination-nav>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center pl-3 pr-3">
            <div class="col-sm-12 px-0">
                <b-modal id="bv-modal-shift-create" :title="modalTitle" ok-variant="primary" hide-footer :busy="saving" :no-close-on-esc="saving" :no-close-on-backdrop="saving">
                    <b-form @submit.stop.prevent="onSubmit">
                        <b-form-group label="Name" class="required-field" label-for="name">
                            <b-form-input id="name" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3, regex: /^[A-Za-z0-9&()\/,_.\- ]+$/ }" :state="validateState('name')" :data-vv-as="roster == 1 ? 'Shift Name' : 'Office Time Settings Name'"/>
                            <b-form-invalid-feedback v-if="veeErrors.has('name')">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-row>
                            <b-col sm="6">
                                <b-form-group label="Code" label-for="code" class="required-field">
                                    <b-form-input id="code" name="code" v-model.trim="fdata.code" v-validate="{ required: true, min: 1, regex: /^[A-Za-z0-9&()\/,_.\- ]+$/ }" data-vv-as="Code" :state="validateState('code')" aria-describedby="code-feedback"/>
                                    <b-form-invalid-feedback id="code-feedback" v-if="veeErrors.has('code')">{{ veeErrors.first('code') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" class="roster-color-code">
                                <b-form-group id="color-group">
                                    <div class="d-flex align-items-center justify-content-between ibox">
                                        <label for="color" class="px-4 py-3 text-dark mb-0 font-weight-bold text-nowrap">
                                            Color
                                            <span class="d-block text-secondary font-weight-normal">{{ fdata.color }}</span>
                                        </label>
                                        <b-form-input id="color" name="color" v-model="fdata.color" type="color" class="border-0 p-0" style="height: 68px; min-width: 180px;" />
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-form-row>

                        <div class="bg-wash p-3 rounded">
                            <div class="approve-level-content p-0 pb-2 text-center form-group d-flex flex-column border-bottom">
                                <template v-if="roster == 1">
                                    <span class="salary-heads text-muted">Shift Scheduling</span>
                                    <label class="text-muted">Set shift timings; working hours auto-calculate from shift start/end time minus break time.</label>
                                </template>
                                <template v-else>
                                    <span class="salary-heads text-muted">Office Scheduling</span>
                                    <label class="text-muted">Set office timings; working hours auto-calculate from office start/end time minus break time.</label>
                                </template>
                                
                            </div>
                            <b-form-row>
                                <b-col sm="6">
                                    <b-form-group label="Office Start Time" label-for="start_time" class="required-field">
                                        <b-form-timepicker :labelCloseButton="'Save'" :disabled="fdata.id != null" id="start_time" name="start_time" v-model="fdata.start_time" v-validate="'required'" data-vv-as="Start time"
                                            :state="validateState('start_time')" minutes-step="5" reset-button :show-seconds="false" locale="en-US" :hour12="true" aria-describedby="start_time-feedback"/>
                                        <b-form-invalid-feedback id="start_time-feedback" v-if="veeErrors.has('start_time')">{{ veeErrors.first('start_time') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="6">
                                    <b-form-group label="Office End Time" label-for="end_time" class="required-field">
                                        <b-form-timepicker :labelCloseButton="'Save'" :disabled="fdata.id != null" id="end_time" name="end_time" v-model="fdata.end_time" v-validate="'required'" data-vv-as="End time" :state="validateState('end_time')"
                                            minutes-step="5" reset-button :show-seconds="false" locale="en-US" :hour12="true" aria-describedby="end_time-feedback"/>
                                        <b-form-invalid-feedback id="end_time-feedback" v-if="veeErrors.has('end_time')">{{ veeErrors.first('end_time') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </b-form-row>

                            <b-form-row>
                                <b-col sm="6">
                                    <b-form-group label="Start Window (Minutes)" label-for="window_start" class="required-field">
                                        <b-form-input id="window_start" name="window_start" v-model="fdata.window_start" v-validate="{required: true, numeric: true, min_value: 0}" :state="validateState('window_start')"
                                            aria-describedby="window_start-feedback" data-vv-as="Office Start"/>
                                        <b-form-invalid-feedback id="window_start-feedback" v-if="veeErrors.has('window_start')">{{ veeErrors.first('window_start') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="6">
                                    <b-form-group label="End Window (Minutes)" label-for="window_end" class="required-field">
                                        <b-form-input id="window_end" name="window_end" v-model="fdata.window_end" v-validate="{required: true, numeric: true, min_value: 0}" :state="validateState('window_end')"
                                            aria-describedby="window_end-feedback" data-vv-as="Break Minutes"/>
                                        <b-form-invalid-feedback id="window_end-feedback" v-if="veeErrors.has('window_end')">{{ veeErrors.first('window_end') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </b-form-row>

                            <b-form-row>
                                <b-col sm="6">
                                    <b-form-group label="Break Time (Minutes)" label-for="break_minutes" class="required-field">
                                        <b-form-input id="break_minutes" name="break_minutes" v-model="fdata.break_minutes" v-validate="{required: true, numeric: true, min_value: 0}" :state="validateState('break_minutes')"
                                            aria-describedby="break_minutes-feedback" data-vv-as="Break Minutes"/>
                                        <b-form-invalid-feedback id="break_minutes-feedback" v-if="veeErrors.has('break_minutes')">{{ veeErrors.first('break_minutes') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="6">
                                    <b-form-group label="Working hours" class="my-0">
                                        <b-input-group class="my-0">
                                            <b-form-input class="my-0" :value="working.hhmm" disabled />
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-form-row>
                        </div>

                        <div class="d-flex flex-row justify-content-between form-group mb-0 pb-3 mt-4 border-bottom">
                            <div>
                                <label class="info-head mb-0"><strong>Break Times Included Working Hours</strong></label><br>
                                <label class="leave-profile sub-header mb-0">Turn this on to include break time, off to exclude it from working hours.</label>
                            </div>
                            <div>
                                <b-form-checkbox class="roster-small-switch" size="lg" v-model="fdata.break_included" name="break_included" switch :value="1" :unchecked-value="0"/>
                            </div>
                        </div>

                        <div class="d-flex flex-row justify-content-between mt-3 form-group mb-0 pb-3 border-bottom" v-if="isNightShift()">
                            <div>
                                <label class="info-head mb-0"><strong>Night Shift(Cross Day) Allowance</strong></label><br>
                                <label class="leave-profile sub-header mb-0">Enable if office time spans across two calendar days</label>
                            </div>
                            <div>
                                <b-form-checkbox class="roster-small-switch" size="lg" v-model="fdata.is_night" name="is_night" switch :value="1" :unchecked-value="0"/>
                            </div>
                        </div>

                        <div class="d-flex flex-row justify-content-between mt-3 form-group mb-0 pb-3" v-if="grace">
                            <div>
                                <label class="info-head mb-0"><strong>Grace Time</strong></label><br>
                                <label class="leave-profile sub-header mb-0">Enable to allow a grace period before late or early deductions are applied.</label>
                            </div>
                            <div>
                                <b-form-checkbox class="roster-small-switch" size="lg" v-model="fdata.grace" name="grace" switch :value="1" :unchecked-value="0"/>
                            </div>
                        </div>

                        <b-alert show variant="warning" v-if="timeWarning" class="mt-2">
                            End time matches start time. Please review.
                        </b-alert>

                        <div class="btn-wrapper text-center pt-5">
                            <b-button variant="primary" v-if="fdata.id == null" type="submit">Submit</b-button>
                            <b-button variant="primary" v-else type="submit">Update</b-button>
                            <b-button variant="primary" class="ml-2 custom-wizard-btn" @click="resetForm">Reset</b-button>
                        </div>
                    </b-form>
                </b-modal>
            </div>
        </div>

    </div>
</template>

<script>
import moment from "moment";

export default {
    data() {
        return {
            loading: false,
            saving: false,
            shifts: [],
            search: '',
            grace: false,
            fdata: {
                id: null,
                name: '',
                code: '',
                start_time: '',
                end_time: '',
                window_start: 30,
                window_end: 30,
                break_minutes: 0,
                is_night: 0,
                break_included: 0,
                grace: 0,
                color: '#000000',
            },
            edit: false,
            roster:0,
            pagination: { currentPage: 1, pages: 1 },
            length_options: [
                { value: 20, text: "20" },
                { value: 50, text: "50" },
                { value: 100, text: "100" },
                { value: 500, text: "500" },
                { value: 1500, text: "1500" },
            ],
            temp_length: 20,
            modalTitle: '',
        }
    },
    computed: {
        // modalTitle(){
        //     return this.roster == 1 ? 'Create New Shift' : 'Create New Office Time Setting';
        // },
        filteredData() {
            let filtered_list = this.shifts;
            if (this.search) {
                filtered_list = filtered_list.filter((row) => {
                    return Object.keys(row).some((key) => {
                        return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                    });
                });
            }
            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.temp_length, this.pagination.currentPage);
        },
        timeWarning() {
            return this.fdata.start_time && this.fdata.end_time && this.fdata.start_time == this.fdata.end_time;
        },
        working() {
            const mins = this._netMinutes(this.fdata);
            const hh = Math.floor(mins / 60);
            const mm = String(mins % 60).padStart(2, '0');
            return {
                minutes: mins,
                hhmm: `${hh}:${mm}`,
                decimal: (mins / 60).toFixed(2),
            };
        },
    },
    mounted() {
        this.loadShifts();
        this.getCompanyLeaveSettings();
    },
    methods: {
        moment,
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        isNightShift() {
            const start_time = this.fdata.start_time;
            const end_time = this.fdata.end_time;
            if (!start_time || !end_time) return false;
            const [startHour, startMin] = start_time.split(':').map(Number);
            const [endHour, endMin] = end_time.split(':').map(Number);
            const startTotal = startHour * 60 + startMin;
            const endTotal = endHour * 60 + endMin;
            return endTotal <= startTotal ? 1 : 0;
        },
        loadShifts() {
            this.loading = true;
            axios.get('/leave-attendance/shifts').then((response) => {
                this.shifts = response.data;
                this.loading = false;
            }).catch(error => {
                this.serverError(error);
                this.loading = false;
            });
        },
        getCompanyLeaveSettings: function () {
            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/leave-attendance/company/leave/settings').then(function (response) {
                if (response.data.length != 0) {
                    let allow_grace_time_late_check_in = response.data.allow_grace_time_late_check_in;
                    let allow_grace_time_early_checkout = response.data.allow_grace_time_early_checkout;
                    this.grace = (allow_grace_time_late_check_in == 1) || (allow_grace_time_early_checkout == 1);
                    this.roster = response.data.roster;
                }
            }.bind(this));
        },
        resetForm() {
            this.edit = false;
            this.fdata = {
                id: null,
                name: '',
                code: '',
                start_time: '',
                end_time: '',
                window_start: 30,
                window_end: 30,
                break_minutes: 0,
                is_night: 0,
                break_included: 0,
                grace: 0,
                color: '#000000',
            };
        },
        openCreate() {
            this.resetForm();
            this.modalTitle = this.roster == 1 ? 'Create New Shift' : 'Create New Office Time Setting';
            this.$bvModal.show('bv-modal-shift-create');
        },
        openEdit(s) {
            this.edit = true;
            this.fdata = {
                id: s.id,
                name: s.name,
                code: s.code,
                start_time: s.start_time,
                end_time: s.end_time,
                window_start: s.window_start,
                window_end: s.window_end,
                is_night: s.is_night,
                break_included: s.break_included,
                break_minutes: s.break_minutes,
                grace: s.grace,
                color: s.color,
            };
            this.modalTitle = this.roster == 1 ? 'Edit Shift' : 'Edit Office Time Setting';
            this.$bvModal.show('bv-modal-shift-create');
        },
        onSubmit(evt) {
            this.$validator.validateAll().then(result => {
                if (!result) return;
                if (this.fdata.is_night == 1 && this.isNightShift() == 0) {
                    this.$bvToast.toast('Night schedule combination is not correct.', { variant: 'danger', solid: true, title: 'Failed' });
                    return;
                }
                this.saving = true;
                let method = this.fdata.id ? 'put' : 'post';
                axios[method]('/leave-attendance/shifts', this.fdata).then(() => {
                    this.$bvToast.toast(this.fdata.id ? 'Shift updated.' : 'Shift created.', {
                        variant: 'success', solid: true, title: 'Success',
                    });
                    this.loadShifts();
                    this.$bvModal.hide('bv-modal-shift-create');
                    this.resetForm();
                    this.saving = false;
                }).catch(e => {
                    this.saving = false;
                    this.serverError(e);
                });
            });
        },
        remove(id) {
            this.$bvModal.msgBoxConfirm('Are you sure you want to delete this item?', {
                title: 'Please Confirm', 
                bodyClass:"text-center",
                okVariant: 'primary', okTitle: 'Delete', cancelTitle: 'Cancel', centered: true, footerClass:"border-0 d-flex flex-row justify-content-center"
            }).then(ok => {
                if (!ok) return;
                axios.delete(this.$api_url + `/leave-attendance/shifts/${id}`).then(() => {
                    this.$bvToast.toast('Deleted.', { variant: 'success', solid: true, title: 'Success' });
                    this.loadShifts();
                }).catch(e => { this.serverError(e); });
            });
        },
        _parseHM(str) {
            if (!str) return null;
            const v = String(str).trim();
            const m = /^(\d{2}):(\d{2})(?::\d{2})?$/.exec(v);
            if (!m) return null;
            const h = Number(m[1]), mm = Number(m[2]);
            if (h < 0 || h > 23 || mm < 0 || mm > 59) return null;
            return [h, mm];
        },
        _diffMinutesAcrossMidnight(start, end) {
            const s = this._parseHM(start), e = this._parseHM(end);
            if (!s || !e) return 0;
            const sMin = s[0] * 60 + s[1];
            let eMin = e[0] * 60 + e[1];
            if (eMin < sMin) eMin += 24 * 60;
            return eMin - sMin;
        },
        _netMinutes(s) {
            const raw = this._diffMinutesAcrossMidnight(s.start_time, s.end_time);
            if (s.break_included == 1) return Math.max(0, raw);
            else return Math.max(0, raw - Math.max(0, s.break_minutes));
        },
        computeWorking(s) {
            const mins = this._netMinutes(s);
            const hh = Math.floor(mins / 60);
            const mm = String(mins % 60).padStart(2, '0');
            return `${hh}H ${mm}m`;
        },
    },
}
</script>
